var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:{ small: _vm.small },style:({
    backgroundColor: 'var(--palette-lightblue-v50)',
    color: 'var(--palette-lightblue-v600)',
  })},[_vm._v("\n  Candidate\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }